import React from "react";
import styled from "styled-components";
import { Link, scroller } from "react-scroll";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import Logo from "../../assets/img/logo.png";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  var isOtherNav = window.location.pathname !== "/"; // true or false
  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <a href="/" className="pointer flexNullCenter">
            <img
              src={Logo}
              alt="logo"
              style={{ width: "190px", height: "auto" }}
            />
          </a>
        </div>
        <CloseBtn
          onClick={() => toggleSidebar(!sidebarOpen)}
          className="animate pointer"
        >
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font15 pointer whiteColor">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="whiteColor"
            activeClass="active"
            style={{ padding: "10px 15px" }}
            to="home"
            spy={true}
            smooth={true}
            offset={-80}
          >
            Home
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="whiteColor"
            activeClass="active"
            style={{ padding: "10px 15px" }}
            to="ourmisson"
            spy={true}
            smooth={true}
            offset={-80}
          >
            Our Mission
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="whiteColor"
            activeClass="active"
            style={{ padding: "10px 15px" }}
            to="aboutus"
            spy={true}
            smooth={true}
            offset={-80}
          >
            About Us
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="whiteColor"
            activeClass="active"
            style={{ padding: "10px 15px" }}
            to="ouractivites"
            spy={true}
            smooth={true}
            offset={-80}
          >
            Our Activities
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="whiteColor"
            activeClass="active"
            style={{ padding: "10px 15px" }}
            to="joinus"
            spy={true}
            smooth={true}
            offset={-80}
          >
            Join Us
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="whiteColor"
            activeClass="active"
            style={{ padding: "10px 15px" }}
            to="contact"
            spy={true}
            smooth={true}
            offset={-80}
          >
            Contact Us
          </Link>
        </li>
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
